<div class="widget form-group" [class.has-error]="control.invalid">
  <label [attr.for]="id" class="horizontal control-label">
    {{ schema.title }}
    <sp-widget-tooltip [widget]="this"></sp-widget-tooltip>
  </label>
  <input [name]="name" class="text-widget file-widget" [attr.id]="id"
    [formControl]="control" type="file" [attr.disabled]="schema.readOnly?true:null"
    (change)="onFileChange($event)" />
  <input *ngIf="schema.readOnly" [attr.name]="name" type="hidden" [formControl]="control" />
  <span *ngIf="schema.description" class="help-block">{{ schema.description }}</span>
  <sp-widget-error [widget]="this" [errors]="control.errors"></sp-widget-error>
</div>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/file.widget.html